export default "__VITE_ASSET__Bt4wII2z__"